import React, {useState} from "react";
import {css} from "@emotion/css";
import {Alert, AlertTitle} from "@mui/lab";
import {FormControl, Grid} from "@mui/material";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";
import {useNavigate} from "react-router-dom";
import {doUserLoginOut} from "../Sidebar/logout/LogOut";
import {
    RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoSectionContainer,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";

const ChangeUserName = (
    {
        adminId = -1,
        service,
        hint = "بعد از تغییر نام کاربری به صورت خودکار از برنامه خارج می شوید و لازم است مجددا با نام کاربری جدید وارد برنامه شوید.",
        refreshDetailInfo
    }) => {

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const [username, setUsername] = useState("");

    const navigate = useNavigate()
    const dispatch = useAuthDispatcher()


    function changeUserName() {
        if (username.length > 7) {
            loading.show()

            if (adminId >= 0)
                updateManagerUserName()
            else
                updateOwnAdminUsername()


        } else {
            showWarningMessage("نام کاربری باید حداقل 8 کاراکتر باشد!")
        }
    }

    function updateManagerUserName() {
        service.updateManagerUserNameById(adminId, username)
            .then(response => {
                if (refreshDetailInfo)
                    refreshDetailInfo()
                setUsername("")
                showSuccessMessage("نام کاربری با موفقیت تغییر پیدا کرد!")
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function updateOwnAdminUsername() {
        loading.show()
        service.updateUserName(username)
            .then(response => {
                setUsername("")
                showSuccessMessage("نام کاربری با موفقیت تغییر پیدا کرد!")
                if (adminId === -1)
                    doUserLoginOut(dispatch, navigate)

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 1rem`}>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"ویرایش نام کاربری"}
                    hasActionButton
                    actionButtonOnclick={changeUserName}
                >
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            title={"لطفا نکات زیر را مورد توجه قرار دهید:"}
                            type={raikoAlertTypes.error}
                            description={[hint]}
                        />
                        <RaikoMaterialOutlinedInput
                            labelText={"نام کاربری جدید"}
                            placeHolder={"لطفا کاربری مورد نظر را وارد نمایید..."}
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}
export default ChangeUserName